/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Page_When_OverlineInputs */

const en_mk_cmp_page_when_overline = /** @type {(inputs: Mk_Cmp_Page_When_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When to pick Multica`)
};

const id_mk_cmp_page_when_overline = /** @type {(inputs: Mk_Cmp_Page_When_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapan pilih Multica`)
};

/**
* | output |
* | --- |
* | "When to pick Multica" |
*
* @param {Mk_Cmp_Page_When_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_page_when_overline = /** @type {((inputs?: Mk_Cmp_Page_When_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Page_When_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_page_when_overline(inputs)
	return en_mk_cmp_page_when_overline(inputs)
});